<template>
  <div :class="{ row: display === 'row' }">
    <label
      v-if="label"
      :for="identifier"
      :style="{ width: labelWidth + 'px' }"
      >{{ label }}</label
    >
    <multiselect
      :value="value"
      :options="options"
      @input="update"
      :multiple="multiple"
      :hide-selected="true"
      :close-on-select="true"
      :clear-on-select="true"
      :label="optionLabel"
      :track-by="optionTrackBy"
      :internal-search="false"
      :loading="isLoading"
      :limit-text="limitText"
      :options-limit="100"
      @search-change="asyncFind"
      placeholder="Pick a value"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
// import axios from "axios";
// import { config } from 'vue/types/umd';
import axios from '../../helpers/Axios'

export default {
  name: "MultiSelectAsyncInput",
  components: { Multiselect },
  data() {
    return {
      options: [],
      isLoading: false,
      total: 0,
    };
  },
  props: [
    "label",
    "value",
    "identifier",
    "display",
    "labelWidth",
    "type",
    "attrs",
    "optionLabel",
    "optionTrackBy",
    "multiple",
    "url",
  ],
  methods: {
    update: function (event) {
      if (this.multiple) {
        this.$emit("input", event);
        this.$emit("valueChanged", event);
      } else {
        this.$emit("input", event[this.optionTrackBy]);
        this.$emit("valueChanged", event[this.optionTrackBy]);
      }
    },
    limitText(count) {
      return `and ${count} other entries`;
    },
    asyncFind(query) {
      this.isLoading = true;
      // var token = store.getters['authmodule/token'];
      // config.headers.Authorization = `Bearer ${token}`;
      return axios
        .post(this.url, { Query: query })
        .then((response) => {
          this.options = response.data.item1;
          this.total = response.data.item2;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearAll() {
      this.selectedCountries = [];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
$lightgrey: #afafaf;

div.row {
  display: flex;
}

label {
  margin-top: 8px;
  margin-bottom: 5px;
  display: block;
}

.multiselect {
  width: 100%;
}

input::-webkit-input-placeholder {
  color: $lightgrey;
}

input::-moz-placeholder {
  color: $lightgrey;
}

input:-ms-input-placeholder {
  color: $lightgrey;
}

input:-moz-placeholder {
  color: $lightgrey;
}
</style>
